import React from 'react';
import SectionHeader from '../shared/SectionHeader';
import Card from '../shared/Card';
import hero from '../images/hero.jpg'; // Example image, replace with actual image path

const AboutSection = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <SectionHeader
          title="About"
          highlight="Storage Sprint"
          subtitle="Pioneering the future of on-demand storage solutions in South Africa."
        />
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-20">
          <div className="animate-slide-up">
            <h3 className="text-3xl font-bold mb-6 text-gray-800">Our Story</h3>
            <p className="text-gray-600 mb-6">
              Founded in 2023, Storage Sprint emerged from a simple idea: storage should be as easy as ordering a ride. We saw the challenges individuals and businesses faced with traditional storage solutions and set out to revolutionize the industry.
            </p>
            <p className="text-gray-600 mb-6">
              Today, we're proud to be South Africa's fastest-growing on-demand storage service, combining cutting-edge technology with personalized service to deliver an unmatched customer experience.
            </p>
            <div className="flex flex-wrap gap-4">
              <div className="bg-yellow-50 text-yellow-600 px-4 py-2 rounded-full font-medium">
                <i className="fas fa-users mr-2"></i> 500+ Customers
              </div>
              <div className="bg-yellow-50 text-yellow-600 px-4 py-2 rounded-full font-medium">
                <i className="fas fa-map-marker-alt mr-2"></i> 2 Cities
              </div>
              <div className="bg-yellow-50 text-yellow-600 px-4 py-2 rounded-full font-medium">
                <i className="fas fa-warehouse mr-2"></i> 1 Facility
              </div>
            </div>
          </div>
          <div className="relative rounded-2xl overflow-hidden shadow-xl animate-slide-up" style={{ animationDelay: "0.2s" }}>
            <img 
              src={hero} 
              alt="Our Team" 
              className="w-full h-auto"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent opacity-70"></div>
            <div className="absolute bottom-0 left-0 p-8 text-white">
              <h3 className="text-2xl font-bold mb-2">Our Team</h3>
              <p>Dedicated professionals committed to your storage needs</p>
            </div>
          </div>
        </div>
        
        {/* Mission & Vision */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <Card
            icon="fas fa-bullseye"
            title="Our Mission"
            content="To transform storage access by providing fast, reliable, and accessible services that empower individuals and businesses to manage their storage needs with unmatched convenience."
            className="bg-yellow-50 animate-slide-up"
            style={{ animationDelay: "0.3s" }}
          />
          
          <Card
            icon="fas fa-eye"
            title="Our Vision"
            content="We envision a future where every person, from students to small business owners, can securely and affordably store and transport belongings with ease through innovative technology."
            className="bg-yellow-50 animate-slide-up"
            style={{ animationDelay: "0.4s" }}
          />
        </div>
      </div>
    </section>
  );
};

export default AboutSection;